import { Flex, Paper, Text } from '@mantine/core';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import { useIsDocumentsRoot } from '@/hooks/useIsDocumentsRoot';
import { useOrganizationChatAiPageStore } from '@/stores/local/pages/OrganizationChatAiPageStore';

import ChartTip from './ChartTip';

import s from './ChartTips.module.scss';

type ChartTipsProps = {
  emptyText?: string;
};

const ChartTips: React.FC<ChartTipsProps> = ({ emptyText }) => {
  const { chartTipsStore, fieldText } = useOrganizationChatAiPageStore();
  const isDocumentsRoot = useIsDocumentsRoot();

  React.useEffect(() => {
    if (chartTipsStore.meta.isInitialMetaState) {
      chartTipsStore.fetchChartTips();
    }
  }, [chartTipsStore]);

  const hasTips = !chartTipsStore.collection.isEmpty;
  const isLoading = chartTipsStore.meta.isLoading || chartTipsStore.meta.isInitialMetaState;
  const shouldShowEmptyState = !hasTips && !isLoading;

  return (
    <Paper className={s.root} shadow="none" radius="md">
      {hasTips ? (
        <>
          <Text className={s.root__title} size="sm">
            Подсказки для вопроса
          </Text>
          <Flex className={s.root__list}>
            {chartTipsStore.collection.items.map((tip) => (
              <ChartTip key={tip.id} tip={tip} setTip={fieldText.setValue} />
            ))}
          </Flex>
        </>
      ) : (
        shouldShowEmptyState && (
          <Text ta="center" size="sm" c="dimmed" className={s.root__empty}>
            {emptyText ??
              (isDocumentsRoot
                ? 'Задайте вопрос помощнику'
                : 'Выберите документ слева для анализа или задайте вопрос помощнику')}
          </Text>
        )
      )}
    </Paper>
  );
};

export default observer(ChartTips);
